import { useContext } from 'react';
import AuthContext from 'App/auth/AuthContext';

export const useAuth = () => {
  return useContext(AuthContext);
};
